import { createFileRoute } from "@tanstack/react-router";
import { SettingsSupport } from "@/screens/ParentSettingsSections";
export const Route = createFileRoute("/parent/settings/support")({ component: SettingsSupport });
